<template>
	<div class="login mh-700">
		<v-container fluid>
			<v-layout row>
				<v-flex xs12>
					<div class="page-heading">
						<v-layout row wrap>
							<v-flex xs12 md10>
								<div class="heading-text">
									<h2>{{ subtitle }}</h2>
								</div>
							</v-flex>
						</v-layout>
					</div>
				</v-flex>

				<v-flex xs12>
					<transition name="component-fade" mode="out-in">
						<component
							v-bind:is="currentFormComponent"
							v-on:return-to-login="
								currentFormComponent = 'LoginForm'
							"
						></component>
					</transition>
				</v-flex>

				<!-- Forgot Password Link -->
				<v-flex xs10 offset-xs2>
					<p class="login-forgot-password mt-5">
						Forgot password?
						<span v-on:click="showComponent('ResetPasswordForm')"
							>Reset password</span
						>
					</p>
				</v-flex>

				<!-- Sign Up as New User -->
				<v-flex xs10 offset-xs2>
					<p class="login-sign-up">
						No account yet?
						<a href="/create-new-user">Sign up!</a>
					</p>
				</v-flex>
			</v-layout>
		</v-container>
	</div>
</template>
<script>
import LoginForm from '@/components/LoginForm';
import ResetPasswordForm from '@/components/ResetPasswordForm';
import ViewHeader from '@/components/ViewHeader.vue';
export default {
	name: 'Login',
	components: {
		LoginForm,
		ResetPasswordForm,
		ViewHeader
	},
	data: function() {
		return {
			subtitle: 'Login',
			currentFormComponent: 'LoginForm'
		};
	},
	methods: {
		showComponent: function(component) {
			this.currentFormComponent = component;
		}
	}
};
</script>
<style src="@/style.css"></style>
